import { type Address, type Hex } from 'viem';

class InvalidHexError extends Error {
  readonly name = 'InvalidHexError';

  readonly value: string;

  constructor({ value }: { value: string }) {
    super('Must be a valid hex value that starts with 0x');

    this.value = value;
  }
}

export function assertIsHex(value: string): asserts value is Hex {
  if (!isHex(value, { strict: false })) throw new InvalidHexError({ value });
}

export function assertIsHexList(list: string[]): asserts list is Hex[] {
  list.forEach(assertIsHex);
}

export function isHex(value: unknown, { strict = true }: { strict?: boolean } = {}): value is Hex {
  if (!value) return false;
  if (typeof value !== 'string') return false;
  return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith('0x');
}

export function isHexList(list: unknown[]): list is Hex[] {
  return list.every(value => isHex(value));
}

const addressRegex = /^0x[a-fA-F0-9]{40}$/;

export function isAddress(address: string): address is Address {
  return addressRegex.test(address);
}
